module.exports = __webpack_public_path__ + "media/night/392-17d03afa.svg";